import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {Field} from 'redux-form';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A Virtualized SelectInput form component with Product Type choices.
 *
 */
class ProductTypeSelectInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectChoices: [],
            selectedId: null,
            selectedProductType: null
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        // Assemble the URI
        const params = {
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductTypes.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        // Retrieve the data and assign results to the Select choices
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                let choices = this.assembleChoiceNames(result.data.payload);
                this.setState({
                    selectChoices: choices
                });
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    };

    assembleChoiceNames(choices) {
        for (let choice of choices) {
            const id = choice.id;
            const name = (choice.name) ? ' - ' + choice.name : '';
            choice.display_name = id + name;
        }
        return choices;
    }

    handleSelectChange = (event, index) => {
        const selectedId = index;
        // Retrieve the Product Type from the choices list based on the selected ID
        if (selectedId) {
            const productType = this.state.selectChoices.find(p => p.id === selectedId);
            if (productType) {
                this.setState({
                    selectedId: selectedId
                }, () => {
                    // Update the parent component with the selection
                    this.props.onSelectProductType(productType);
                });
            }
        } else {
            this.setState({
                selectedId: null
            }, () => {
                this.props.onSelectProductType(null);
            });
        }
    };

    render() {
        return (
            <Field name="product_type_select"
                   component={VirtualizedSelectInput}
                   choices={this.state.selectChoices}
                   label={this.props.label}
                   optionText="display_name"
                   onChange={this.handleSelectChange}
                   allowEmpty
                   options={{
                       className: "full-width",
                       clearable: false,
                       placeholder: "Select a Product Type",
                   }}
            />
        );
    }
}

ProductTypeSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    onSelectProductType: PropTypes.func.isRequired,
};

ProductTypeSelectInput.defaultProps = {
    addField: true,
};

export default ProductTypeSelectInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductTypeSelectInput.js